import React, { useContext, useEffect, useState } from 'react';
import '../../App.css';
import { Button as MuiButton, Divider, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import Geocode from 'react-geocode';
import { UserSessionContext } from '../../App';
import { createPaymentAccount, getPaymentAccount } from '../../models/actions/PaymentsAccount';
import SpButton from '../../components/atoms/SpButton';
import SpText from '../../components/atoms/SpText';

//Setting up geocode
const PaymentDashboard = (props) => {
  const [accountPaymentDetails, setAccountPaymentDetails] = useState();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const createStripeAccount = async () => {
    try {
      const { accountLink } = await createPaymentAccount({ user_id: authData.userId }, authData.accessToken);
      window.open(accountLink);
    } catch (error) {
      console.error(error);
    }
  };
  const goToStripeAccount = async () => {
    try {
      // TODO NAVIGATE TO THE STRIPE ACCOUNT
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    try {
      const accountDetails = await getPaymentAccount({ user_id: authData.userId }, authData.accessToken);
      setAccountPaymentDetails(accountDetails);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {!accountPaymentDetails ? (
          <SpButton
            text="Crea il tuo account Stripe"
            variant={'tableAction'}
            onClick={createStripeAccount}
          />
        ) : (
          <>
            <Grid
              container
              direction="column"
            >
              <Grid
                item
                xs={12}
                style={{ display: 'flex' }}
              >
                <SpButton
                  text="Accedi a Stripe per gestire i tuoi pagamenti"
                  variant={'tableAction'}
                  onClick={goToStripeAccount}
                />
              </Grid>

              <Grid
                item
                xs={12}
                style={{ display: 'flex' }}
              >
                <SpText
                  variant={'tableText'}
                  style={{ fontWeight: 'bold !important' }}
                >
                  {'ID ACCOUNT : '}
                </SpText>
                <SpText variant={'tableText'}>{accountPaymentDetails.account_id}</SpText>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default withSnackbar(PaymentDashboard);
